import React, { forwardRef } from "react";

import { DisplayNumberProps } from "./types";
import { formatCurrency } from "../../utils";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography/Typography";

export const DisplayCurrency = forwardRef<
  HTMLSpanElement,
  Omit<DisplayNumberProps, "shortenThreshold"> & {
    currencyCode?: string;
    currencyPosition?: string;
  }
>(
  (
    {
      value,
      variant = "Body 2",
      currencyCode = "USD",
      currencyPosition = "right",
      thousandSeparator = ",",
      decimalSeparator = ".",
      trimDecimals = true,
      decimalSpaces = 2,
      format = "long",
      disableTooltip = false,
      className,
      as = "span",
      ...rest
    },
    ref
  ) => {
    const formattedValue = formatCurrency(
      value,
      thousandSeparator,
      decimalSeparator,
      trimDecimals,
      decimalSpaces,
      "short",
      currencyCode,
      currencyPosition
    );

    const formattedLongValue = formatCurrency(
      value,
      thousandSeparator,
      decimalSeparator,
      trimDecimals,
      decimalSpaces,
      "long",
      currencyCode,
      currencyPosition
    );

    if (format === "short") {
      return (
        <Tooltip
          title={formatCurrency(
            value,
            thousandSeparator,
            decimalSeparator,
            false,
            decimalSpaces,
            "long",
            currencyCode,
            currencyPosition
          )}
          disable={
            disableTooltip ||
            (!formattedLongValue.includes(thousandSeparator) &&
              !formattedLongValue.includes(decimalSeparator))
          }
        >
          <Typography
            as={as}
            variant={variant}
            className={className}
            ref={ref}
            {...rest}
          >
            {formattedValue}
          </Typography>
        </Tooltip>
      );
    }

    return (
      <Typography
        as={as}
        variant={variant}
        className={className}
        ref={ref}
        {...rest}
      >
        {formattedLongValue}
      </Typography>
    );
  }
);

DisplayCurrency.displayName = "DisplayCurrency";
